import { Action } from './actions';
import { FiltersState } from './filtersState';

export function filtersReducer(state: FiltersState, action: Action): FiltersState {
  switch (action.type) {
    case 'selectPlexFilterItem': {
      const { permalink, selected } = action.payload;

      const selectedPlexPermalinks = ((): string[] => {
        const { selectedPlexPermalinks } = state;
        if (selected) {
          if (!selectedPlexPermalinks.includes(permalink)) {
            return [...selectedPlexPermalinks, permalink];
          }
        } else {
          if (selectedPlexPermalinks.includes(permalink)) {
            return selectedPlexPermalinks.filter((plexPermalink) => plexPermalink !== permalink);
          }
        }

        return selectedPlexPermalinks;
      })();

      return {
        ...state,
        selectedPlexPermalinks,
        router: {
          ...state.router,
          plexSummaryPermalink: getNewPlexSummaryId(state?.router.plexSummaryPermalink, selectedPlexPermalinks),
        },
      };
    }
    case 'selectAllPlexesFilterItem': {
      const { selected, plexPermalinks } = action.payload;

      const selectedPlexPermalinks = ((): string[] => {
        const { selectedPlexPermalinks } = state;
        if (selected) {
          const selectedPlexPermalinksToAdd = Array.from(plexPermalinks).filter(
            (plexPermalink) => !selectedPlexPermalinks.includes(plexPermalink)
          );
          return [...selectedPlexPermalinks, ...selectedPlexPermalinksToAdd];
        } else {
          return selectedPlexPermalinks.filter((plexPermalink) => !plexPermalinks.has(plexPermalink));
        }
      })();

      return {
        ...state,
        selectedPlexPermalinks,
        router: {
          ...state.router,
          plexSummaryPermalink: getNewPlexSummaryId(state?.router.plexSummaryPermalink, selectedPlexPermalinks),
        },
      };
    }
    case 'selectOnlyOnePlexFilterItem': {
      const { permalink, selected } = action.payload;

      const selectedPlexPermalinks = ((): string[] => {
        if (selected) {
          return [permalink];
        } else {
          return [];
        }
      })();

      return {
        ...state,
        selectedPlexPermalinks,
        router: {
          ...state.router,
          plexSummaryPermalink: getNewPlexSummaryId(state?.router.plexSummaryPermalink, selectedPlexPermalinks),
        },
      };
    }

    case 'labelSelect': {
      return {
        ...state,
        labelIds: action.payload.labelIds,
      };
    }
    case 'labelClearAll': {
      return {
        ...state,
        labelIds: [],
      };
    }

    case 'selectPublishStatusFilter': {
      return {
        ...state,
        publishStatusFilter: action.payload.pickedPublishStatusFilter,
      };
    }

    case 'showPlexSummary': {
      return {
        ...state,
        router: {
          ...state.router,
          plexSummaryPermalink: action.payload.permalink,
        },
      };
    }

    case 'selectTasksItemTypeFilter': {
      return {
        ...state,
        tasks: {
          ...state.tasks,
          itemType: action.payload.itemType,
        },
      };
    }

    case 'selectTasksOrderFilter': {
      return {
        ...state,
        tasks: {
          ...state.tasks,
          order: action.payload.order,
        },
      };
    }
  }

  return state;
}

const getNewPlexSummaryId = (currentId: string | undefined, selectedPlexes: string[]): string | undefined => {
  if (selectedPlexes.length === 1) {
    return selectedPlexes[0];
  }

  if (!!currentId && selectedPlexes.indexOf(currentId) !== -1) {
    return currentId;
  }

  return undefined;
};
